// extracted by mini-css-extract-plugin
export default {"notificationTooltipList":"NotificationBadgesTooltip__notificationTooltipList___AwNtH"};